import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { AppRemixIcon } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import { UnmountClosed } from 'react-collapse/lib/UnmountClosed';
import colors from '../../../../constants/colors';
import Translator from '../../../components/helpers/Translator';

export default function UserManagementInfoModules(props) {
  const { moduleBridge, module, isOpen, onOpen } = props;
  const auth = useSelector((state) => state.auth);

  // const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="card border mt-2">
      <div
        className={`${
          module.type === 'LegalCompliance' ? 'bg-light pointer' : ''
        } p-1`}
        onClick={() =>
          module.type === 'LegalCompliance' ? onOpen(module.id) : undefined
        }
      >
        <div>
          <span className="mr-2">
            <img
              src={
                module.image !== null ? module.image : auth.user.client.logoUrl
              }
              // src="https://worldlex.net/assets/images/modules/cards/gcl.png"
              className="img-responsive"
              style={{ height: '30px' }}
            />
          </span>
          <span className="ml-1 text-primary">
            {module.name}
            {module.type === 'LegalCompliance' &&
              moduleBridge.showUserPermissions === true && (
                <>
                  <small className=" ml-3">
                    (
                    {ReactDOMServer.renderToString(
                      <Translator
                        file="general"
                        name={
                          module.permission === 0
                            ? 'administrator'
                            : module.permission === 1
                            ? 'complete-manager'
                            : 'limited'
                        }
                      />
                    )}
                    )
                  </small>
                </>
              )}
          </span>
        </div>

        {module.plants?.length > 0 && (
          <UnmountClosed
            isOpened={isOpen?.includes(module.id) && module.plants}
          >
            {module.plants?.map((plant) => (
              <div className="p-2 ml-4 mr-4" key={plant.hex}>
                <div className="bg-white">
                  <div className="p-1">
                    {/* <img
                    src={
                      plant.image
                        ? plant.image
                        : 'https://worldlex.net/assets/images/modules/cards/gcl.png'
                    }
                    // src="https://worldlex.net/assets/images/modules/cards/gcl.png"
                    className="img-responsive"
                    style={{ height: '30px' }}
                  /> */}
                    <span className="ml-1 text-primary">{plant.name}</span>
                  </div>
                </div>
              </div>
            ))}

            <div className="p-2 ml-4 mr-4">
              <div
                style={{ backgroundColor: '#fff3cd' }}
                className="text-primary"
              >
                <div className="d-inline-flex align-items-center p-1">
                  <AppRemixIcon
                    icon={`${module.emailNotification ? 'check' : 'close'}`}
                    color={`${
                      module.emailNotification ? colors.success : colors.danger
                    }`}
                  />
                  <span className="ml-2">
                    <Translator
                      file="module-userManagement"
                      name="module.um.notification-obligations-email"
                    />
                  </span>
                </div>
              </div>
            </div>
          </UnmountClosed>
        )}
      </div>
    </div>
  );
}
